// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".saveBtns[data-v-51d23f8a]{width:100%;text-align:center;margin-top:50px}", ""]);
// Exports
module.exports = exports;
